import { Message } from 'primeng/api';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserLoginService } from '../user-login.service';
import { CognitoCallback } from '../cognito.service';

@Component({
    selector: 'app-forgot-password-1',
    templateUrl: './forgot-password-1.component.html'
})
export class ForgotPassword1Component implements CognitoCallback {
    email: string;
    errorMessages: Message[];

    constructor(public router: Router,
        public userService: UserLoginService) {
        this.errorMessages = [];
    }

    onNext() {
        this.errorMessages = [];
        this.userService.forgotPassword(this.email, this);
    }

    cognitoCallback(message: string, result: any) {
        if (message == null && result == null) { // error
            this.router.navigate(['/forgotPassword', this.email]);
        } else { // success
            this.errorMessages = [({ severity: 'error', detail: message })];
        }
    }
}

